var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.tituloPronto && _vm.$route.name === "informacoesCadastro"
    ? _c(
        "div",
        { staticClass: "card-info" },
        [
          _vm.showModalVisualizaPdf
            ? _c("app-modal-visualiza-pdf", {
                attrs: {
                  titulo: this.tituloOrCertidao.tipo,
                  tipo: "TITULO_CERTIDAO",
                  conteudo: _vm.conteudoModal
                },
                on: {
                  closeModal: function($event) {
                    _vm.showModalVisualizaPdf = false
                  }
                }
              })
            : _vm._e(),
          _c("el-row", [
            _c(
              "div",
              { staticClass: "d-flex tb" },
              [
                _c("span", { staticClass: "verde-text center" }, [
                  _vm._v(
                    _vm._s(
                      this.tituloOrCertidao.proNome +
                        " " +
                        this.tituloOrCertidao.info +
                        " está disponível! "
                    )
                  )
                ]),
                _c(
                  "el-button",
                  {
                    staticClass: "green textButtonBreak",
                    attrs: { tipo: "success" },
                    on: {
                      click: function($event) {
                        _vm.showModalVisualizaPdf = true
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "center" }, [
                      _c("i", { staticClass: "fal fa-eye" }),
                      _vm._v(
                        "  " +
                          _vm._s(
                            "Visualizar informações do(a) " +
                              this.tituloOrCertidao.info
                          )
                      )
                    ])
                  ]
                )
              ],
              1
            )
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b8694db", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b8694db","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/processos/AppDownloadTitulo.vue
// module id = null
// module chunks = 